var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"title"}},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.item.name))]),_c('p',{staticClass:"description"},[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }